export const isStagingEnv = process.env.CONTENT_PREVIEW === 'false';
export const isBrowser = () => typeof window !== 'undefined';
export const isLocalHost =
  isBrowser() && window?.location?.hostname === 'localhost';
